export default "__VITE_ASSET__f4528396__"